
const Pagination = {
    currentPage: 1,
    itemToShow: 8,
}

export class Constant {
    static Pagination = Pagination;
}